import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import * as RolesRouteMap from 'app-models';
import { BENEFICIARY } from 'app-models';
import { DeleteDialogLibraryComponent } from 'delete-dialog-library';
import { getStepDetails, updateStepStatus, updateStepStatusToInitialState } from 'visa-store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { sync_profile_code } from 'permission-library';
import { environment } from 'environment-configurations';
import * as i3 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'primeng/dynamicdialog';
import * as i6 from '@angular/router';
import * as i7 from 'app-services-library';
import * as i8 from 'reference-library';

class APIEducationDetails {
    constructor(http) {
        this.http = http;
    }
    getBeneDetails(visatype, caseType, caseId, synctype, superTaskId, subTaskId, isUsedForBenEdit) {
        return this.http.get(`/${visatype}/${caseType}/${caseId}/${synctype}?superTaskId=${superTaskId}&taskId=${subTaskId}&isUsedForBenEdit=${isUsedForBenEdit}`).pipe(map((response) => {
            if (response && (response.status === 200 || response.status === 204)) {
                return response;
            }
        }));
    }
    syncProfileData(visatype, caseType, caseId, synctype, superTaskId, subTaskId) {
        return this.http.post(`/${visatype}/${caseType}/${caseId}/${synctype}/overall/sync?superTaskId=${superTaskId}&taskId=${subTaskId}`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    syncAllBeneDetails(visatype, caseType, caseId, synctype, superTaskId, subTaskId) {
        return this.http.post(`/${visatype}/${caseType}/${caseId}/${synctype}/sync?superTaskId=${superTaskId}&taskId=${subTaskId}`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    syncBeneId(visatype, caseType, caseId, synctype, superTaskId, subTaskId, educationId) {
        return this.http.post(`/${visatype}/${caseType}/${caseId}/${synctype}/${educationId}/sync?superTaskId=${superTaskId}&taskId=${subTaskId}`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    deleteBeneDetails(visatype, caseType, caseId, synctype, superTaskId, subTaskId, educationId) {
        return this.http.delete(`/${visatype}/${caseType}/${caseId}/${synctype}/${educationId}?superTaskId=${superTaskId}&taskId=${subTaskId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    syncBeneWorkExperienceAll(visatype, caseType, caseId, synctype, superTaskId, subTaskId, syncType) {
        return this.http.post(`/${visatype}/${caseType}/${caseId}/${synctype}/sync?superTaskId=${superTaskId}&taskId=${subTaskId}&syncType=${syncType}`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    syncProfileAll(caseId, type) {
        return this.http.post(`/petition/updateProfile/${caseId}/${type}`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    deleteCourseDetails(visatype, caseType, caseId, synctype, superTaskId, subTaskId, educationId, courseId) {
        return this.http.delete(`/${visatype}/${caseType}/${caseId}/${synctype}/${educationId}/COURSE/${courseId}?superTaskId=${superTaskId}&taskId=${subTaskId}`).pipe(map((response) => {
            return response;
        }));
    }
    deleteDocuments(visatype, caseType, caseId, documentId) {
        return this.http.delete(`/${visatype}/${caseType}/${caseId}/document/${documentId}`).pipe(map((response) => {
            return response;
        }));
    }
}
APIEducationDetails.ɵfac = function APIEducationDetails_Factory(t) { return new (t || APIEducationDetails)(i0.ɵɵinject(i1.HttpClient)); };
APIEducationDetails.ɵprov = i0.ɵɵdefineInjectable({ token: APIEducationDetails, factory: APIEducationDetails.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APIEducationDetails, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const DeleteDialogConfigurations = {
    width: '50%',
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { "z-index": "1001" }
};
const ImportDialogConfigurations = {
    width: '50%',
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { "z-index": "1001" },
    header: 'Educational'
};
const ImportDialogTrainingConfigurations = {
    width: '50%',
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { "z-index": "1001" },
    header: 'Training'
};
const ImportDialogLicenceConfigurations = {
    width: '50%',
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { "z-index": "1001" },
    header: 'Licenses & Certifications'
};
const NoteDialogConfigurations = {
    width: '40%',
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { "z-index": "1001" },
    data: {}
};
class BaseEducationDetailsLibraryService {
    constructor(store, apiService, toastr, stepStatusUpdatePayloadCostruction, dialogService, router, appServicesLibraryService, referenceLibrary) {
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.dialogService = dialogService;
        this.router = router;
        this.appServicesLibraryService = appServicesLibraryService;
        this.referenceLibrary = referenceLibrary;
        this.getSummaryMessaege$ = new Subject();
        this.observableSubscription$ = new Subject();
        this.onSaveEmitSubject = new Subject();
        this.href = "";
        this.typeOfButton = null;
        this.userType = sessionStorage.getItem('userTypeRole');
        this.disabledControls = false;
        this.notifyDestinationUser = BENEFICIARY;
        this.questionnaire = false;
        this.isEducationView = true;
        this.educationCols = [
            { field: 'degree', header: 'Degree' },
            { field: 'fieldOfStudy', header: 'Field of Study' },
            { field: 'university', header: 'University Name' },
            { field: 'grade', header: 'Grade' },
            { field: 'startYear', header: 'Start Year' },
            { field: 'endYear', header: 'Year Completed' },
            { field: 'action', header: 'Action' },
        ];
        this.educationSubCols = [
            { field: 'addressLine1', header: 'Address 1' },
            { field: 'addressLine2', header: 'Address 2' },
            { field: 'city', header: 'City' },
            { field: 'countryCode', header: 'Country' },
            { field: 'stateProvinceName', header: 'State' },
            { field: 'postCode', header: 'ZIP / Postal Code' },
        ];
        this.trainingCols = [
            { field: 'name', header: 'Name' },
            { field: 'subjects', header: 'Topic of Study' },
            { field: 'institution', header: 'Institution' },
            { field: 'startDate', header: 'Start Date' },
            { field: 'endDate', header: 'End Date' },
            { field: 'action', header: 'Action' },
        ];
        this.linceseCols = [
            { field: 'name', header: 'Name' },
            { field: 'subjects', header: 'Topic of Study' },
            { field: 'institution', header: 'Institution' },
            { field: 'startDate', header: 'Start Date' },
            { field: 'endDate', header: 'End Date' },
            { field: 'action', header: 'Action' },
        ];
        this.questionnaire = window.location.pathname === "/beneficiary-profile/profile" ? true : false;
    }
    loadInit() {
        if (sessionStorage.getItem('wizardTID')) {
            this.getEducationList();
            this.getLicensesList();
            this.getTrainingList();
        }
        else {
            // Get Specific step details by passing step code
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                if (data) {
                    this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
                    this.stepDetails = data;
                    this.toggleControlsStatus();
                    this.getEducationList();
                    this.getLicensesList();
                    this.getTrainingList();
                }
            });
        }
        // there is no save, so on landing of the page we are updating status to "INPROGRESS" if status is "NEW"
        //Jun 17, 22 commenting the logic since we have start(play) button on the screen
        // if (this.stepDetails && this.stepDetails.stepStatusDetails && this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
        //   this.updateStepStatus('INPROGRESS');
        // }
    }
    getEducationList() {
        this.apiService.getBeneDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_EDUCATION, this.inputData.superTaskId, this.inputData.subTaskId, false).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            this.educationList = response.status === 200 ? response.data : [];
            this.educationList.forEach((item, index) => {
                var _a;
                if ((item === null || item === void 0 ? void 0 : item.stateProvinceCode) && ((_a = item === null || item === void 0 ? void 0 : item.country) === null || _a === void 0 ? void 0 : _a.countryCode)) {
                    this.updateStateName(item, index);
                }
            });
        });
    }
    updateEducation() {
        let a = window.location.href;
        if (a.toString().includes('/beneficiary-profile')) {
            window.location.href = window.location.origin + '/beneficiary-profile/profile?prop=BENE&section=2';
        }
        else {
            let listBeneficiaryId = (sessionStorage.getItem('beneficiaryId'));
            sessionStorage.setItem('listBeneficiaryId', listBeneficiaryId);
            sessionStorage.setItem('bene-profile-viewMode', 'false');
            // console.log(window.location.href);
            let url;
            if (this.userType === RolesRouteMap.ATTORNEY) {
                url = [`${RolesRouteMap.userRoleRouteMapping[this.userType]}/attorney/beneficiary/profile/profile-details`, { listview: true }];
            }
            else {
                url = [`${RolesRouteMap.userRoleRouteMapping[this.userType]}/beneficiaries/profile/profile-details`, { listview: true }];
            }
            this.router.navigate(url, { state: { redirectUrl: this.router.url, redirectPage: 'Back to Petition Builder' } });
            sessionStorage.setItem('bene-update-experience', 'true');
            sessionStorage.removeItem('bene-update-profile');
        }
    }
    syncSingleEduaction(input) {
        this.apiService.syncBeneId(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_EDUCATION, this.inputData.superTaskId, this.inputData.subTaskId, input.id).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.toastr.success(response.message, 'Success');
                this.getEducationList();
            }
        });
    }
    deleteEducationList(input) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.apiService.deleteBeneDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_EDUCATION, this.inputData.superTaskId, this.inputData.subTaskId, input.id).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    this.toastr.success(response.message, 'Success');
                    this.getEducationList();
                });
            }
        });
    }
    deleteCoursesList(subeducationlist, item) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.apiService.deleteCourseDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_EDUCATION, this.inputData.superTaskId, this.inputData.subTaskId, subeducationlist.id, item.courseId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    this.toastr.success(response.message, 'Success');
                    this.getEducationList();
                });
            }
        });
    }
    deleteDocumentsList(subeducationlist, item) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.apiService.deleteDocuments(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, item.id).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    this.toastr.success(response.message, 'Success');
                    this.toastr.success(response.message, 'Success');
                    this.getEducationList();
                });
            }
        });
    }
    getTrainingList() {
        this.apiService.getBeneDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_TRAINING, this.inputData.superTaskId, this.inputData.subTaskId, false).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            this.trainingList = response.status === 200 ? response.data : [];
        });
    }
    handleTrainingSync(input) {
        this.apiService.syncBeneId(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_TRAINING, this.inputData.superTaskId, this.inputData.subTaskId, input.id).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.toastr.success(response.message, 'Success');
                this.getTrainingList();
            }
        });
    }
    deleteTrainingList(input) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.apiService.deleteBeneDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_TRAINING, this.inputData.superTaskId, this.inputData.subTaskId, input.id).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    this.toastr.success(response.message, 'Success');
                    this.getTrainingList();
                });
            }
        });
    }
    deleteTrainingDocumentsList(subeducationlist, item) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.apiService.deleteDocuments(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, item.id).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    this.toastr.success(response.message, 'Success');
                    this.getTrainingList();
                });
            }
        });
    }
    getLicensesList() {
        this.apiService.getBeneDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_LICENSE, this.inputData.superTaskId, this.inputData.subTaskId, false).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            this.licensesList = response.status === 200 ? response.data : [];
        });
    }
    syncEduMerge() {
        this.apiService.syncBeneWorkExperienceAll(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, 'EDUCATION', this.inputData.superTaskId, this.inputData.subTaskId, 'merge').pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.toastr.success(response.message, 'Success');
                this.getEducationList();
            }
        });
    }
    syncEduReset() {
        this.apiService.syncBeneWorkExperienceAll(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, 'EDUCATION', this.inputData.superTaskId, this.inputData.subTaskId, 'reset').pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.toastr.success(response.message, 'Success');
                this.getEducationList();
            }
        });
    }
    syncTraMerge() {
        this.apiService.syncBeneWorkExperienceAll(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, 'TRAINING', this.inputData.superTaskId, this.inputData.subTaskId, 'merge').pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.toastr.success(response.message, 'Success');
                this.getTrainingList();
            }
        });
    }
    syncTraReset() {
        this.apiService.syncBeneWorkExperienceAll(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, 'TRAINING', this.inputData.superTaskId, this.inputData.subTaskId, 'reset').pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.toastr.success(response.message, 'Success');
                this.getTrainingList();
            }
        });
    }
    syncLinMerge() {
        this.apiService.syncBeneWorkExperienceAll(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, 'LICENSE', this.inputData.superTaskId, this.inputData.subTaskId, 'merge').pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.toastr.success(response.message, 'Success');
                this.getLicensesList();
            }
        });
    }
    syncLinReset() {
        this.apiService.syncBeneWorkExperienceAll(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, 'LICENSE', this.inputData.superTaskId, this.inputData.subTaskId, 'reset').pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.toastr.success(response.message, 'Success');
                this.getLicensesList();
            }
        });
    }
    handleLicensesSync(input) {
        this.apiService.syncBeneId(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_LICENSE, this.inputData.superTaskId, this.inputData.subTaskId, input.id).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.toastr.success(response.message, 'Success');
                this.getLicensesList();
            }
        });
    }
    deleteLicensesList(input) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.apiService.deleteBeneDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_LICENSE, this.inputData.superTaskId, this.inputData.subTaskId, input.id).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    this.toastr.success(response.message, 'Success');
                    this.getLicensesList();
                });
            }
        });
    }
    deleteLicensesDocumentsList(subeducationlist, item) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.apiService.deleteDocuments(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, item.id).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    this.toastr.success(response.message, 'Success');
                    this.getLicensesList();
                });
            }
        });
    }
    openDoc(item) {
        const docPath = item.fileLocation.substring(23);
        window.open(`${environment.docs}${docPath}`, '_blank');
    }
    onRowExpand(event) {
        // console.log(event.data);
    }
    //Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
        // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
    }
    updateStepStatus(status) {
        this.store.dispatch(updateStepStatus({
            payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
            subTaskId: this.stepDetails.taskId,
            visaType: this.inputData.caseType === 'I130' ?
                this.inputData.caseType : this.inputData.visatype,
            stepId: this.inputData.stepId
        }));
    }
    sycProfilePitition() {
        this.apiService.syncProfileAll(this.inputData.caseId, 'EDUCATION').pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.toastr.success(response.message, 'Success');
                this.getEducationList();
                this.getLicensesList();
                this.getTrainingList();
            }
        });
    }
    onClickEditImmigation() {
        this.isEducationView = !this.isEducationView;
    }
    saveCloseEditEducation() {
        this.isEducationView = true;
        this.getEducationList();
        this.getLicensesList();
        this.getTrainingList();
    }
    onDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        // Update the Step Status state to empty state
        this.store.dispatch(updateStepStatusToInitialState());
    }
    postFormSubmission() {
        if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
            this.getSummaryMessaege$.subscribe((res) => {
                if (res.indexOf('Successfully') > -1) {
                    this.updateStepStatus('INPROGRESS');
                }
            });
        }
    }
    onGetApiStatus(event) {
        this.getSummaryMessaege$.next(event);
    }
    updateStateName(item, i) {
        var _a;
        if (!item)
            return false;
        this.referenceLibrary.getStatesFromApi((_a = item === null || item === void 0 ? void 0 : item.country) === null || _a === void 0 ? void 0 : _a.countryCode).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response === null || response === void 0 ? void 0 : response.length) {
                const stateObj = response.find(x => x.stateProvinceCode === (item === null || item === void 0 ? void 0 : item.stateProvinceCode));
                this.educationList[i].stateProvinceName = (stateObj) ? stateObj.stateProvinceName : '';
            }
        });
    }
}
BaseEducationDetailsLibraryService.ɵfac = function BaseEducationDetailsLibraryService_Factory(t) { return new (t || BaseEducationDetailsLibraryService)(i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(APIEducationDetails), i0.ɵɵinject(i3.ToastrService), i0.ɵɵinject(i4.StepStatusUpdatePayloadService), i0.ɵɵinject(i5.DialogService), i0.ɵɵinject(i6.Router), i0.ɵɵinject(i7.AppServicesLibraryService), i0.ɵɵinject(i8.ReferenceLibraryService)); };
BaseEducationDetailsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseEducationDetailsLibraryService, factory: BaseEducationDetailsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseEducationDetailsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.Store }, { type: APIEducationDetails }, { type: i3.ToastrService }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.DialogService }, { type: i6.Router }, { type: i7.AppServicesLibraryService }, { type: i8.ReferenceLibraryService }]; }, null); })();

/*
 * Public API Surface of base-education-details-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APIEducationDetails, BaseEducationDetailsLibraryService, DeleteDialogConfigurations, ImportDialogConfigurations, ImportDialogLicenceConfigurations, ImportDialogTrainingConfigurations, NoteDialogConfigurations };
//# sourceMappingURL=base-education-details-library.js.map
